import { IsFeatureEnabled as IsGroupFeatureEnabled } from 'owa-group-feature-flags';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
export default function isGroupsEnabled() {
    if (IsGroupFeatureEnabled('grp-useGroupsEnabledFromUserConfiguration')) {
        var userConfiguration = getUserConfiguration();
        return userConfiguration.GroupsEnabled;
    }
    else {
        return !isConsumer();
    }
}
//# sourceMappingURL=IsGroupsEnabled.js.map